import React from "react";
import { ImageResizeMode, Platform, StyleProp, ViewStyle } from "react-native";
import { GalleryCategory } from "./GalleryType";
import { Diamond } from "@src/types/DiamondDetail";
import { ImageContentFit } from "expo-image";
import { SearchResultsAndFavoritesEnum } from "@utils/product/searchResultConstants";

export interface IProps {
  close?: () => void;
  testIDPrefix?: string;
  hideThumbs?: boolean;
  images?: ImageObject[];
  initialIndex?: number;
  isOpen?: boolean;
  resizeMode?: ImageResizeMode;
  thumbColor?: string;
  thumbDefaultBorderColor?: string;
  thumbSize?: number;
  iconSize?: number;
  thumbResizeMode?: ImageResizeMode;
  disableSwipe?: boolean;
  handleItemClick?: any;
  isExternalView?: GalleryCategory;
  pagingEnableds?: boolean;
  image_thumb_url?: string;
  isSmallDeviceWidth?: boolean;
  imageWidth?: number;
  //updateIndex: (index: number) => void;
  scrollToIndexInternal?: number;
  handleOpenExpandModel?: any;
  applyRadius?: boolean;
  cotainerWidth?: number;
  resizeImage?: boolean;
  productType?: string;
  itemDetail?: Diamond;
  extraSmallImage?: boolean;
  isClickable?: boolean;
  scrollEnabled?: boolean;
  addExtraPadding?: boolean;
  isMatchModel?: boolean;
  showExpand?: boolean;
  showMediaModel?: boolean;
  isSmallVideoView?: boolean;
  GIACertEnable?: boolean;
  setMediaActiveIndex?: any;
  mediaActiveIndex?: number;
  fromReviewPage?: boolean;
  isJewelryComponent?: boolean;
  onRemoveMedia?: (index: number, media_id: number) => void;
  isModal?: boolean;
  onShareViaNativeFromModal?: (mediaUrl: string) => void;

  renderCustomThumb?: (
    item: ImageObject,
    index: number,
    isSelected: boolean
  ) => React.ReactNode;

  renderCustomImage?: (
    item: ImageObject,
    index: number,
    isSelected: boolean
  ) => React.ReactNode;

  renderHeaderComponent?: (
    item: ImageObject,
    currentIndex: number
  ) => React.ReactNode;

  renderFooterComponent?: (
    item: ImageObject,
    currentIndex: number
  ) => React.ReactNode;
}

export interface HeaderProps {
  currentIndex: number;
  item?: ImageObject;
}

export interface FooterProps {
  currentIndex: number;
  total: number;
  centerString?: string;
  hasArrow?: boolean;
  leftClickEvent?: any;
  rightClickEvent?: any;
  ceterIconTheme?: string;
  preText?: string;
  postText?: string;
  enableArrowsOnEnd?: boolean;
}

export interface ImageObject {
  id: number;
  order?: string | number;
  thumb?: string;
  link: string;
  type: string;
  video_type: string;
  lab?: string;
}

export interface ImagePreviewProps {
  index: number;
  isSelected: boolean;
  item: ImageObject;
  resizeMode?: ImageContentFit;
  handleItemClick?(): any;
  activeIndex?: number;
  isSmallDeviceWidth?: boolean;
  deviceWidth?: number;
  applyRadius?: boolean;
  resizeImage?: boolean;
  extraSmallImage?: boolean;
  shape?: string;
  isExternalView?: string;
  isMatchModel?: boolean;
  showMediaModel?: boolean;
  isSmallVideoView?: boolean;
  itemID?: number;
  certNum?: string;
  GIACertEnable?: boolean;
  fromStickyHeader?: boolean;
  threeDMedia?: any[];
  stoneType?: string;
  onRemoveMedia?: (index: number, media_id: number) => void;
  linkedPairChildren?: Diamond[];

  renderCustomImage?: (
    item: ImageObject,
    index: number,
    isSelected: boolean
  ) => React.ReactNode;
}

export interface RenderImageProps {
  item: ImageObject;
  index: number;
  resizeMode?: ImageResizeMode;
}

export const shareMenuOptions = (t: any, isVDB?: boolean) => {
  const options = [
    {
      name: SearchResultsAndFavoritesEnum.SHARE_EMAIL,
      label: t("shareScreen.shareMenu.pdp.email.text"),
    },
    {
      name: SearchResultsAndFavoritesEnum.SHARE_NATIVE,
      label: t("shareScreen.shareMenu.pdp.native.text"),
    },
    ...(Platform.OS !== "web" || isVDB
      ? [
          {
            name: SearchResultsAndFavoritesEnum.SHARE_MEDIA,
            label: t("shareScreen.shareMenu.pdp.media.text"),
            webLabel: "shareScreen.shareMenu.pdp.web.media.text",
          },
        ]
      : []),
  ];
  return options;
};

export interface CarouselItemProps {
  testID?: string;
  item: ImageObject;
  index: number;
  itemDetail: Diamond;
  activeIndex: number;
  image_thumb_url: string;
  changeActiveIndex: (index: number) => void;
  thumbColor: string;
  thumbSize: number;
  thumbResizeMode: ImageResizeMode;
  thumbDefaultBorderColor: string;
  iconSize: number;
  onRemoveMedia?: (index: number, media_id: number) => void;
}

export interface CarouselPreviewProps {
  activeIndex: number;
  slides: ImageObject[];
  width: string;
  height: string;
  resizeMode: ImageContentFit;
  extraSmallImage: boolean;
  handleOpenExpandModel: () => void;
  handleItemClick: () => void;
  renderCustomImage: (
    item: ImageObject,
    index: number,
    isSelected: boolean
  ) => React.ReactNode;
  isSmallDeviceWidth: boolean;
  deviceWidth: number;
  applyRadius: boolean;
  resizeImage: boolean;
  isExternalView: string;
  shape: string;
  isMatchModel: boolean;
  showMediaModel: boolean;
  isSmallVideoView: boolean;
  itemDetail: Diamond;
}

export type CarouselProps = {
  testIDPrefix?: string;
  data: ImageObject[];
  itemDetail: Diamond;
  activeIndex: number;
  vertical: boolean;
  image_thumb_url: string;
  changeActiveIndex: (index: number) => void;
  thumbColor: string;
  thumbSize: number;
  thumbResizeMode: ImageResizeMode;
  thumbDefaultBorderColor: string;
  style: StyleProp<ViewStyle>;
  imageWidth: number;
  iconSize: number;
  onRemoveMedia?: (index: number, media_id: number) => void;
};
